import { render, staticRenderFns } from "./public.vue?vue&type=template&id=6f52c662&scoped=true&"
import script from "./public.vue?vue&type=script&lang=ts&"
export * from "./public.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f52c662",
  null
  
)

export default component.exports